// Tempo (segundos) que o balão "Escolha a tensão" do card fica aberto.
// Ajustável em Gerenciador > Personalizar > Modo Edição > clicar no balão.
// Gravado em admin/data/carousel_settings.json, seção "tensao", campo "interval"
// (lido por api.getConfigCarrosseis()). A pré-visualização do Personalizar envia
// o valor na hora via postMessage ({ source: 'mx3-theme-customizer-preview', voltpickSecs }).
import Vue from "vue";
import api from "@/api";

export const BALAO_TENSAO_PADRAO = 3;
export const BALAO_TENSAO_MIN = 1;
export const BALAO_TENSAO_MAX = 30;

function valido(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  if (!isFinite(n)) return null;
  return Math.max(BALAO_TENSAO_MIN, Math.min(BALAO_TENSAO_MAX, n));
}

const estado = Vue.observable({ salvo: null, previa: null, previaDefinida: false });
let iniciado = false;

function iniciar() {
  if (iniciado || typeof window === "undefined") return;
  iniciado = true;
  try {
    Promise.resolve(api.getConfigCarrosseis())
      .then((sec) => {
        const t = sec && sec.tensao;
        estado.salvo = t ? valido(t.interval) : null;
      })
      .catch(() => {});
  } catch (e) { /* usa o padrão */ }
  window.addEventListener("message", (ev) => {
    const d = ev && ev.data;
    if (!d || d.source !== "mx3-theme-customizer-preview" || !("voltpickSecs" in d)) return;
    estado.previa = valido(d.voltpickSecs);
    estado.previaDefinida = true;
  });
}

// Duração em milissegundos.
export function duracaoBalaoTensao() {
  iniciar();
  const v = estado.previaDefinida ? estado.previa : estado.salvo;
  return Math.round((v !== null ? v : BALAO_TENSAO_PADRAO) * 1000);
}

export function modoEdicaoAtivo() {
  return typeof document !== "undefined" && document.documentElement.classList.contains("mx3-edit-active");
}
